var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CpfForm',{ref:"form",attrs:{"login-type":_vm.loginType},on:{"on-submit":_vm.submit,"toggle-login-type":_vm.toggleLoginType},model:{value:(_vm.identifier),callback:function ($$v) {_vm.identifier=$$v},expression:"identifier"}})}
var staticRenderFns = []

export { render, staticRenderFns }